import React, { Component } from 'react'
import NewLayout from '../layout/newLayout'
import styles from '../styles/scss/pages/contactUs.module.scss'
import SEO from "../components/seo"
import { Formik } from "formik"
import { find as _find } from "lodash"
import { signUp } from "../services/email"
import { sendContact } from "../services/contact"
import PageContents from '../components/pageContents'
import cn from "classnames"
import {
    TextInput,
    Textarea,
    Select,
    Checkbox,
    Fieldset,
    Disclosure,
    ErrorSummary,
    FormStatus,
    SubmitButton,
    RequiredNote,
    bind,
    summaryErrors,
    phoneError,
    zipError,
    US_STATES,
    isValidEmail,
    fieldError,
    formStyles as f,
} from '../components/form'


export default class Index extends Component {

    state = {
        showExtra: false,
        submitted: false,
        submitError: false,
        selectedTopic: null,
        selectedBrand: null,
        selectedProduct: null,
        selectedRegion: null
    };

    topics = [{
        value: 'distributor',
        text: 'Becoming a Distributor',
        collectProductInfo: false,
        collectRegion: true,
        allowSubmit: true
    }]

    brands = [{
        value: 'wd-40',
        text: 'WD-40',
        products: [
            "1-Gallon",
            "3 oz Handy Can",
            "8 oz Smart Straw",
            "11 oz Smart Straw",
            "12 oz Smart Straw",
            "14.4 oz EZ-REACH",
            "18 oz Big Blast Can",
            "No-Mess Pen",
            "No-Mess Pen with Custom Imprint",
            "20 oz Trigger Pro Non-Aerosol",
            "16 oz Industrial Size",
            "Specialist Carb/Throttle Body & Parts Cleaner",
            "Specialist Spray & Stay Gel Lubricant",
            "Specialist Rust Release Penetrant Spray",
            "Specialist Water Resistant Silicone Lubricant",
            "Specialist Protective White Lithium Grease",
            "Specialist Long-Term Corrosion Inhibitor",
            "Specialist Rust Remover Soak",
            "Specialist Dirt & Dust Resistant Dry Lube",
            "Specialist Machine & Engine Degreaser",
            "Specialist Industrial-Strength Degreaser",
            "Specialist Industrial-Strength Cleaner & Degreaser",
            "Specialist Electrical Contact Cleaner Spray",
            "Specialist Superior Performance True Multi-Purpose Grease",
            "Specialist Heavy-Duty High Temperature Grease",
            "Specialist Heavy-Duty Extreme Pressure Grease",
            "Specialist Marine Grade Water Resistant Grease",
            "Other"
        ]
    }, {
        value: '3-in-one',
        text: '3-IN-ONE',
        products: [
            "RVcare Slide-Out Silicone Lube",
            "RVcare Window & Track Dry Lube",
            "Multi-Purpose Drip Oil",
            "Multi-Purpose Telescoping Spout",
            "Motor Oil",
            "Garage Door Lube",
            "Fast-Acting Penetrant",
            "All-Temp Silicone",
            "Dry Lube",
            "Pneumatic Tool Oil",
            "PTFE Lube",
            "Other"
        ]
    }, {
        value: 'lava',
        text: 'Lava',
        products: [
            "Lava Bar",
            "Lava Bar Twin-Pack",
            "Lava Liquid",
            "Other"
        ]
    }, {
        value: 'x-14',
        text: 'X-14',
        products: [
            "Automatic Toilet Bowl Cleaner - Bleach",
            "Automatic Toilet Bowl Cleaner - Blue plus Fragrance",
            "Mildew Stain Remover",
            "Other"
        ]
    }, {
        value: '2000-flushes',
        text: '2000 Flushes',
        products: [
            "Bleach",
            "Blue Plus Bleach",
            "Blue Plus Detergents",
            "Other"
        ]
    }, {
        value: 'carpet-fresh',
        text: 'Carpet Fresh',
        products: [
            "Powder Family",
            "Quick-Dry Foam Family",
            "Other"
        ]
    }, {
        value: 'spot-shot',
        text: 'Spot Shot',
        products: [
            "14 oz. Aerosol",
            "14 oz. Pet Aerosol",
            "18 oz. Professional Aerosol",
            "22 oz. Pet Trigger",
            "22 oz. Trigger",
            "Other"
        ]
    }, {
        value: 'wd-40-bike',
        text: 'WD-40 Bike',
        products: [
            "All-Purpose Bike Wash",
            "Chain Cleaner & Degreaser",
            "All-Conditions Chain Lube",
            "Dry Chain Lubricant",
            "Wet Chain Lubricant"
        ]
    }, {
        value: 'wd-40-motorcycle',
        text: 'WD-40 Motorcycle',
        products: [
            "Total Wash 33 8 Oz",
            "Chain Cleaner 18 Oz",
            "Chain Lube 14 Oz",
            "Chain Wax 13 5 Oz",
            "Total Shine 12 Oz"
        ]
    }]

    regions = [{
        value: 'us',
        text: 'US'
    }, {
        value: 'canada',
        text: 'Canada'
    }]

    ages = [{
        value: 'Under 15',
        text: 'Under 15'
    }, {
        value: '15 to 17',
        text: '15 to 17'
    }, {
        value: '18 to 24',
        text: '18 to 24'
    }, {
        value: '25 to 34',
        text: '25 to 34'
    }, {
        value: '35 to 44',
        text: '35 to 44'
    }, {
        value: '45 to 54',
        text: '45 to 54'
    }, {
        value: '55 to 64',
        text: '55 to 64'
    }, {
        value: '65 or Older',
        text: '65 or Older'
    }]

    genders = [{
        value: 'Male',
        text: 'Male'
    }, {
        value: 'Female',
        text: 'Female'
    }]

    handleClickExtraInfo = () => {
        this.setState({
            showExtra: !this.state.showExtra
        })
    }
    componentDidMount() {
        this.setState({
            selectedTopic: _find(this.topics, { value: 'distributor' }),
            selectedRegion: _find(this.topics, { value: 'us' })
        })

    }

    validate = values => {
        var errors = []
        if (values.firstName === "") {
            errors.push({ field: "firstName", message: "First Name is required" })
        }
        if (values.lastName === "") {
            errors.push({ field: "lastName", message: "Last Name is required" })
        }
        if (values.email === "") {
            errors.push({ field: "email", message: "Email is required" })
        } else if (!isValidEmail(values.email)) {
            errors.push({ field: "email", message: "Invalid email address" })
        }
        const phoneMsg = phoneError(values.phone, { required: true, requiredMessage: "Mobile Phone Number is required" })
        if (phoneMsg) errors.push({ field: "phone", message: phoneMsg })
        const zipMsg = zipError(values.zip, { label: "Zip" })
        if (zipMsg) errors.push({ field: "zip", message: zipMsg })
        if (values.message === null || values.message === "") {
            errors.push({ field: "message", message: "Please enter a comment, question or request" })
        }
        return errors
    }

    onSubmit = (values, { setSubmitting }) => {
        this.setState({ submitError: false })
        const done = () => {
            setSubmitting(false)
            this.setState({ submitted: true })
        }
        sendContact(values).then(() => {
            if (values.lists.length > 0) {
                return signUp({
                    firstName: values.firstName,
                    lastName: values.lastName,
                    email: values.email,
                    lists: values.lists,
                    confirmation: true,
                    signupFormID: 1828532,
                    formIdentifier: 'contact'
                }).then(done, err => {
                    // The distributor request already went through; a failed
                    // newsletter signup must not invite a duplicate resubmission
                    console.log(err)
                    done()
                })
            }
            done()
        }).catch((err) => {
            console.log('ERROR!')
            console.log(err)
            setSubmitting(false)
            this.setState({ submitError: true })
        })
    }

    toggleList = (props, id, checked) => {
        const lists = props.values.lists.filter(l => l !== id)
        props.setFieldValue('lists', checked ? [...lists, id] : lists)
    }

    render() {
        const { showExtra, submitError } = this.state
        const pg = this.props.pageContext.page
        const attached = pg.attachments.filter((att) => {
            return att.slug === 'thank-you-contact'
        })
        var thankyou = null
        if (attached.length > 0) {
            thankyou = attached[0]
        } else {
            throw new Error("thank-you-contact is not attached")
        }
        return (
            <NewLayout>
                {pg.seo.title && <h1 style={{ display: 'none' }}>{pg.seo.title}</h1>}
                <SEO page={pg} />
                <div className='d-flex flex-column flex-fill'>
                    <div className={styles.container}>
                        <div className={cn(styles.formItems, "row")}>
                            <div className={styles.formContainer}>
                                {
                                    this.state.submitted ?
                                        <PageContents content={thankyou.content} />
                                        :
                                        <>
                                            <PageContents content={pg.content} />
                                            <Formik
                                                initialValues={{
                                                    firstName: "",
                                                    lastName: "",
                                                    email: "",
                                                    company: "",
                                                    companyWebsite: "",
                                                    lists: [],
                                                    topic: "distributor",
                                                    brand: null,
                                                    product: null,
                                                    upc: "",
                                                    lotCode: "",
                                                    addr1: "",
                                                    addr2: "",
                                                    city: "",
                                                    state: "",
                                                    zip: "",
                                                    message: "",
                                                    phone: "",
                                                    region: "us",
                                                    group: "distributors"
                                                }}
                                                validate={this.validate}
                                                onSubmit={this.onSubmit}>
                                                {(props) => (
                                                    <form className={f.form} onSubmit={props.handleSubmit} noValidate>
                                                        <RequiredNote />
                                                        <ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
                                                        <FormStatus status={submitError ? "error" : null} />
                                                        <div className={f.row}>
                                                            <TextInput label="First Name" required autoComplete="given-name" placeholder="John" {...bind(props, "firstName")} />
                                                            <TextInput label="Last Name" required autoComplete="family-name" placeholder="Doe" {...bind(props, "lastName")} />
                                                        </div>
                                                        <TextInput label="Email" type="email" required autoComplete="email" placeholder="jdoe@email.com" {...bind(props, "email")} />
                                                        <div className={f.row}>
                                                            <TextInput label="Phone Number" type="tel" mask="phone" required autoComplete="tel-national" placeholder="(000) 000-0000" {...bind(props, "phone")} />
                                                            <TextInput label="Company Name" autoComplete="organization" {...bind(props, "company")} />
                                                        </div>
                                                        <div className={f.row}>
                                                            <TextInput label="Company Website" type="url" placeholder="www.company.com" autoComplete="url" {...bind(props, "companyWebsite")} />
                                                        </div>
                                                        <Disclosure
                                                            id="distributor-extra"
                                                            title="Additional information"
                                                            // Forced open while a field inside has an error, so the
                                                            // message (and the summary link's target) is visible
                                                            open={showExtra || !!fieldError(props, "zip")}
                                                            onToggle={this.handleClickExtraInfo}
                                                        >
                                                            <div className={f.row}>
                                                                <TextInput label="Address" autoComplete="address-line1" {...bind(props, "addr1")} />
                                                                <TextInput label="APT/Suite #" autoComplete="address-line2" {...bind(props, "addr2")} />
                                                            </div>
                                                            <div className={f.row}>
                                                                <TextInput label="City" autoComplete="address-level2" {...bind(props, "city")} />
                                                                <Select label="State" placeholder="Select a State" options={US_STATES} {...bind(props, "state")} />
                                                            </div>
                                                            <div className={f.row}>
                                                                <TextInput label="Zip" autoComplete="postal-code" {...bind(props, "zip")} />
                                                                {/* Still writes the same `phone` value as Mobile Phone Number
                                                                    (known issue, split tracked as a follow-up ticket) */}
                                                                <TextInput id="businessPhone" label="Business Phone" type="tel" mask="phone" {...bind(props, "phone")} error="" />
                                                            </div>
                                                        </Disclosure>
                                                        {/* Fixed for this page (posted as topic "distributor", region "us") */}
                                                        <p className={f.sectionIntro}>
                                                            <strong>Topic:</strong> Becoming a Distributor &nbsp;·&nbsp; <strong>Region:</strong> US
                                                        </p>
                                                        <Textarea label="Comment, Question or Request" required {...bind(props, "message")} />
                                                        <Fieldset id="lists" legend="Sign me up for emails for:">
                                                            {[
                                                                [17512397, <>WD-40<sup>&reg;</sup> Brand Products</>],
                                                                [3174349, <>WD-40<sup>&reg;</sup> Bike Products</>],
                                                                [17513421, "Other WD-40 Company Brands"],
                                                            ].map(([id, label]) => (
                                                                <Checkbox
                                                                    key={id}
                                                                    name="lists"
                                                                    id={`lists-${id}`}
                                                                    label={label}
                                                                    checked={props.values.lists.indexOf(id) > -1}
                                                                    onChange={e => this.toggleList(props, id, e.target.checked)}
                                                                />
                                                            ))}
                                                        </Fieldset>
                                                        <div className={f.actions}>
                                                            <SubmitButton busy={props.isSubmitting}>Submit</SubmitButton>
                                                        </div>
                                                    </form>
                                                )}
                                            </Formik>
                                        </>
                                }
                            </div>
                                <div className={cn(styles.contactData, "col-sm-4")}>
                                    <div className={styles.data}>
                                        <div>
                                            <p>Phone:</p>
                                            <span>WD-40 Customer Relations</span>
                                            <span><a href="tel:18883247596">1.888.324.7596</a></span>
                                        </div>
                                        <div>
                                            <p>Mailing Address:</p>
                                            <span>WD-40 Customer Relations</span>
                                            <span>P.O. Box 308</span>
                                            <span>Budd Lake, NJ, 07828</span>
                                        </div>
                                        <div>
                                            <p>Investor Relations:</p>
                                            <span>Wendy Kelley</span>
                                            <span><a href="tel:18883247596">1.888.324.7596</a></span>
                                            <span>
                                                <a href='mailto:investorrelations@wd40.com'>investorrelations@wd40.com</a>
                                            </span>
                                        </div>

                                        <div className={styles.textExtraInfo}>
                                            * All customer inquiries should be directed to Customer Relations at the phone number or mailing address listed. Product inquiries sent to this email address will not receive a response.
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </NewLayout>
        );
    }
}
